import { defineStore } from 'pinia';
import QuoteAssignService from '@/service/QuoteAssignService';

export const useQuoteAssignStore = defineStore('useQuoteAssignStore', {
  state: () => ({
    assign: {},
    isLoading: false
  }),
  getters: {
    selectAssign: (state) => state.assign,
    doLoading: (state) => state.isLoading
  },
  actions: {
    async handleComplete(id, isSent) {
      const quoteAssignService = new QuoteAssignService();
      const res = await quoteAssignService.generatePdf(id, isSent);
      return res?.data;
    },

    async handleAssign(payload, id) {
      const quoteAssignService = new QuoteAssignService();
      const res = await quoteAssignService.assignService(payload, id);
      return res?.data;
    }
  }
});
